import { Routing } from "helpers/routing";
import React, { createContext } from "react";

const TeamOrganizationDatasourceIdentifierContext = createContext<{
  params?: Routing.TeamOrganizationDatasourceIdentifierParams
}>({})

export { TeamOrganizationDatasourceIdentifierContext }
